if (!customElements.get('subscriptions-widget')) {
  customElements.define('subscriptions-widget', class extends HTMLElement {
    connectedCallback() {
      this.assignData();
      this.cacheElements();
      this.attachEventListeners();
      this.bindFormVariantChange();
      this.alternateButtonToggle = this.querySelector('.alternate-button-toggle');
      if (this.alternateButtonToggle) {
        this.alternateButtonToggle.addEventListener('click', () => {
          this.classList.toggle('subscription-widget__alternate-style');
        });
      }
    }

    assignData() {
      const jsonScript = this.querySelector('script.variant-json');

      if (!jsonScript) {
        console.error('No JSON script tag found');
        this.remove();
        return;
      }

      this.sellingPlan = JSON.parse(jsonScript.textContent || 'null');

      if (!this.sellingPlan) {
        console.error('Selling plan data is empty or invalid');
        this.remove();
        return;
      }
    }

    cacheElements() {
      this.trigger = this.querySelector('.custom-select-trigger');
      this.optionsContainer = this.querySelector('.custom-options');
      this.sellingPlanRadios = this.querySelectorAll('input[name="selling_plan"]');
      this.customOptionRadios = this.querySelectorAll('input[name="delivery-frequency"]');
      this.oneTimePrice = this.querySelector('.one-time-price');
      this.subscriptionPrice = this.querySelector('.subscription__price');
      this.oneTimeLabel = this.querySelector('.option--one-time');
      this.subscribeLabel = this.querySelector('.option--subscribe');
      this.subscribeInput = this.querySelector('#subscribe-save');
      this.reactivePrice = this.closest('vbb-product-form-reactive')?.querySelectorAll('vbb-reactive-price') ?? null
    }

    attachEventListeners() {
      this.trigger.addEventListener('click', () => {
        const isHidden = this.optionsContainer.classList.toggle('hidden');
        this.trigger.setAttribute('aria-expanded', !isHidden);

        if (!isHidden) {
          const firstLabel = [...this.optionsContainer.querySelectorAll('label')]
            .find(label => getComputedStyle(label).display !== 'none');
          if (firstLabel) firstLabel.focus();
        }
      });

      this.sellingPlanRadios.forEach(radio => {
        radio.addEventListener('change', () => {
          const isSubscription = radio.id === 'subscribe-save' || radio.name === 'delivery-frequency';
          this.oneTimeLabel.setAttribute('aria-checked', !isSubscription);
          this.subscribeLabel.setAttribute('aria-checked', isSubscription);
          this.handleRadioChange(radio);
        });
      });

      this.customOptionRadios.forEach(radio => {
        radio.addEventListener('change', () => {
          const label = this.querySelector(`label[for="${radio.id}"]`);
          this.querySelector('.custom-select-trigger__text').textContent = label.textContent;
          radio.checked = true;
          this.optionsContainer.classList.add('hidden');
          this.trigger.setAttribute('aria-expanded', 'false');

          this.subscribeInput.value = radio.value;
          this.subscribeInput.checked = true;
          this.subscribeInput.dispatchEvent(new Event('change', { bubbles: true }));
          this.handleRadioChange(radio)
        });
      });

      const mainOptionLabels = this.querySelectorAll('.option--one-time, .option--subscribe');
      mainOptionLabels.forEach(label => {
        label.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            label.click();
          }
        });
      });

      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) {
          this.optionsContainer.classList.add('hidden');
          this.trigger.setAttribute('aria-expanded', 'false');
        }
      });

      this.optionsContainer.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.optionsContainer.classList.add('hidden');
          this.trigger.setAttribute('aria-expanded', 'false');
          this.trigger.focus();
          return;
        }

        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (document.activeElement.tagName === 'LABEL') {
            document.activeElement.click();
          }
          return;
        }

        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
          e.preventDefault();
          const arrowOptions = [...this.optionsContainer.querySelectorAll('label')]
            .filter(label => getComputedStyle(label).display !== 'none');
          const arrowIndex = arrowOptions.indexOf(document.activeElement);
          const nextArrowIndex = e.key === 'ArrowDown'
            ? (arrowIndex + 1) % arrowOptions.length
            : (arrowIndex - 1 + arrowOptions.length) % arrowOptions.length;
          arrowOptions[nextArrowIndex].focus();
          return;
        }

        if (e.key !== 'Tab') return;
        e.preventDefault();

        const options = [...this.optionsContainer.querySelectorAll('label')]
          .filter(label => getComputedStyle(label).display !== 'none');
        const currentIndex = options.indexOf(document.activeElement);
        const nextIndex = e.shiftKey
          ? (currentIndex - 1 + options.length) % options.length
          : (currentIndex + 1) % options.length;

        options[nextIndex].focus();
      });
    }

    handleRadioChange(radio) {
      const activeVariantId = this.dataset.activeVariantId;
      const sellingPlanPrice = this.sellingPlan[activeVariantId].allocations[radio.value]?.price;
      const variantPrice = this.sellingPlan[activeVariantId].price;
      const isSubscription = radio.id === 'subscribe-save' || radio.name === 'delivery-frequency';

      if(!activeVariantId) {
        console.error('No active variant ID found');
        return;
      }

      if(!activeVariantId || !this.sellingPlan[activeVariantId]) {
        console.error('No selling plan data found');
        return;
      }

      const pricesdiffer = sellingPlanPrice && variantPrice && sellingPlanPrice !== variantPrice;

      // This is to be updated when old form is removed
      // Handles new product form
      if (this.reactivePrice?.length > 0) {
        if (pricesdiffer) {
          this.reactivePrice.forEach(el => {
            el.priceOveride(sellingPlanPrice, variantPrice);
          });
        }

        const reactiveCta = this.closest('form').querySelector('vbb-reactive-cta');
        const reactivePrice = reactiveCta?.querySelector('.reactive-price');
        if (reactivePrice) {
          if (!reactivePrice.dataset.defaultText) reactivePrice.dataset.defaultText = reactivePrice.textContent.trim();
          reactivePrice.innerHTML = isSubscription ? window.variantStrings.subscribe : reactivePrice.dataset.defaultText;
        }
      }
      else {
        // Handles old product form
        const priceElements = document.querySelectorAll('.vbb-product-details__buybox__details__price')

        if(!priceElements) {
          console.error('No price elements found');
          return;
        }

        let priceHtml = variantPrice
        if (pricesdiffer) {
          priceHtml = `<s class="yotpo-strikethrough">${variantPrice}</s> ${sellingPlanPrice}`;
        }
        priceElements.forEach(item => item.innerHTML = priceHtml);

        const atcButton = this.closest('form').querySelector('button[type="submit"]');
        if (atcButton) {
          atcButton.innerHTML = isSubscription ? window.variantStrings.subscribe : `${priceHtml} - ${window.variantStrings.addToBag}`;
        }
      }
    }

    bindFormVariantChange() {
      this.productForm = this.closest('vbb-product-form-reactive');
      if (this.productForm) {
        this.productForm.addEventListener('variant:changed', (event) => {
          const activeVariantId = event.detail.variantId;
          this.setActiveSellingPlan(activeVariantId);
        });
      }
    }

    // Set as own function to accomodate for old and new forms
    setActiveSellingPlan(activeVariantId) {
      this.dataset.activeVariantId = activeVariantId;
      this.resetWidget(activeVariantId);
    }

    resetWidget(activeVariantId) {
      // Sets the dropsdown to the default value
      const defaultRadio = this.querySelector('.custom-options input[type="radio"]');
      if (defaultRadio) {
        defaultRadio.checked = true;
        defaultRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Reverts to one time purchase
      const oneTimeRadio = this.querySelector('#one-time');
      if (oneTimeRadio) {
        oneTimeRadio.checked = true;
        oneTimeRadio.dispatchEvent(new Event('change', { bubbles: true }));
        this.oneTimeLabel.setAttribute('aria-checked', 'true');
        this.subscribeLabel.setAttribute('aria-checked', 'false');
      }

      // Set default subscription price if element exists (only rendered when price differs from regular price)
      const subscriptionPriceEl = this.querySelector('.subscription__price span');
      if (subscriptionPriceEl) {
        subscriptionPriceEl.textContent = this.sellingPlan[activeVariantId].allocations[this.subscribeInput.value].price;
      }
    }
  });
}
